import React, { Fragment } from 'react';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';

import { useTableContext } from '../../contexts';
import { FilterCell } from '../FilterCell';
import { HeadCell } from '../HeadCell';

import styles from './TableHeadSection.module.scss';

export interface ITableHeadSectionProps {}

export const TableHeadSection: React.FC<ITableHeadSectionProps> = () => {
    const {
        getHeaderGroups,
        getAllLeafColumns,
        getRowModel,
        props: { dense, filterBar },
    } = useTableContext();
    const empty = getRowModel().rows.length === 0;
    const showFilterBar =
        filterBar &&
        getAllLeafColumns().some(
            (column) => column.getCanFilter() !== false && column.columnDef.meta?.filtering !== undefined,
        );

    return (
        <thead className={classNames(styles.tableHead)}>
            {getHeaderGroups().map(({ id, headers }) => (
                <Fragment key={id}>
                    <tr className={classNames(styles.tableHeadRow)}>
                        {headers.map((header, index) => (
                            <HeadCell
                                key={header.id}
                                header={header}
                                last={index === headers.length - 1}
                                dense={dense}
                                hideFilterButton={showFilterBar}
                                empty={empty}
                            >
                                {flexRender(header.column.columnDef.header, header.getContext())}
                            </HeadCell>
                        ))}
                    </tr>
                    {showFilterBar && (
                        <tr className={styles.filterRow}>
                            {headers.map((header, index) => (
                                <FilterCell
                                    key={`${header.id}-filter`}
                                    header={header}
                                    last={index === headers.length - 1}
                                />
                            ))}
                        </tr>
                    )}
                </Fragment>
            ))}
        </thead>
    );
};
